import { DataCollectionEventNames } from '@jarvis/jweb-core';
import { createSubscriber, getHost } from 'jweb/jweb';
import { postSimpleUIEvents } from './request';
import { getQueryParams } from './functional';

const params = getQueryParams();
let platform = '';

let eventsToPost = [];
let intervalId;
let MIN_EVENTS_TO_PUSH = 2;
let cdmEventServiceListener = {};

const isSimpleUIEvent = eventData => {
  return eventData.eventCategory === 'simpleUi';
};

const pushEvent = event => {
  console.log('Event pushed to queue ', JSON.stringify(event, null, 2));
  eventsToPost.push({
    Platform: platform,
    AppInstanceId: params.appInstanceId,
    Timestamp: Date.now(),
    Event: event
  });
};

const start = async () => {
  try {
    // Register with Jweb to listen for cdm events
    const subscriber = await createSubscriber();
    platform = await getHost();
    if (typeof subscriber.errorType !== 'undefined') {
      console.log('Error creating subscriber ', JSON.stringify(subscriber, null, 2));
      return;
    }
    cdmEventServiceListener = await subscriber.subscribe(
      {
        eventName: DataCollectionEventNames.cdmEvent
      },
      ({ eventData }) => {
        console.log(`cdmEvent received: ${JSON.stringify(eventData, null, 2)}`);
        const { events } = eventData;

        if (events.length) {
          events.forEach(event => {
            if (isSimpleUIEvent(event)) {
              pushEvent(event);
            }
          });
        }
      }
    );

    if (typeof cdmEventServiceListener.errorType !== 'undefined') {
      console.log(
        'Error subscribing to cdm events ',
        JSON.stringify(cdmEventServiceListener, null, 2)
      );
      return;
    }

    // Check in interval to see if events have to post to BE
    intervalId = setInterval(() => {
      console.log('Current no. of events in queue ', eventsToPost.length);
      if (eventsToPost.length >= MIN_EVENTS_TO_PUSH) {
        postEvents();
      }
    }, 5000);
  } catch (err) {
    console.log('cdmEvent subscription failed.');
  }
};

const postEvents = async () => {
  // console.log('posting started');
  return postSimpleUIEvents(eventsToPost)
    .then(() => {
      console.log(`cdmEvents posted: ${JSON.stringify(eventsToPost, null, 2)}`);
      eventsToPost = [];
    })
    .catch(() => {
      console.log('Failed to post events.');
    });
};

const stop = async () => {
  console.log('stop');
  try {
    if (eventsToPost.length) {
      await postEvents();
    }
  } finally {
    cdmEventServiceListener.isActive && cdmEventServiceListener.unsubscribe();
    clearInterval(intervalId);
    console.log('unsubscribed');
  }
};

const eventsDispatcher = {
  start,
  stop
};

export default eventsDispatcher;
